import { Link, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/useAuth';
import { Button } from '../shared/ui/Button';
import { RtkLogo } from '../shared/ui/RtkLogo';
import { NotificationBell } from '../features/notifications/NotificationBell';
import { OnboardingProvider } from '../features/onboarding/components/OnboardingProvider';
import { useSubscriptionSelectionGuard } from '../features/subscriptions/useSubscriptionGuard';
import { ProfileMenu } from './ProfileMenu';
import { ThemeToggle } from './ThemeToggle';
import { LanguageSwitch } from './LanguageSwitch';

/**
 * Шапка: знак «Ростелеком» слева, пользовательские элементы справа.
 *
 * Онбординг живёт здесь, а не в `App`: его шаги переходят между страницами и ищут якоря
 * в текущем маршруте, поэтому провайдер должен быть внутри контекста роутера.
 */
export function Layout() {
  const { t } = useTranslation();
  const { isAuthenticated, login } = useAuth();
  useSubscriptionSelectionGuard();

  return (
    <OnboardingProvider>
      <div className="min-h-screen">
        <header className="sticky top-0 z-30 border-b border-border bg-surface">
          <div className="mx-auto flex h-16 max-w-6xl items-center gap-3 px-4 md:gap-6">
            <Link to="/" className="shrink-0">
              <RtkLogo />
            </Link>

            <div className="ml-auto flex items-center gap-1.5 sm:gap-2">
              <LanguageSwitch />
              <ThemeToggle />
              <NotificationBell enabled={isAuthenticated} />
              {isAuthenticated ? (
                <ProfileMenu />
              ) : (
                <Button
                  size="sm"
                  onClick={() => {
                    login();
                  }}
                >
                  {t('auth.login')}
                </Button>
              )}
            </div>
          </div>
        </header>

        <main className="mx-auto max-w-3xl px-4 py-8">
          <Outlet />
        </main>
      </div>
    </OnboardingProvider>
  );
}
